import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { AttachDetachStepperModel as AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';
import { AppClientConfigurationService } from '@sdbn/common';
import { TMCClientParameters } from '@sdbn/tmc-common';

@Component({
  selector: 'app-detach-truck',
  templateUrl: './detach-truck.component.html',
  styleUrls: ['./detach-truck.component.scss']
})
export class DetachTruckComponent implements OnInit {

  stepperModel: AttachDetachStepperModel;

  formGroup = new FormGroup({
    trailerNumberPlate: new FormControl(null, [Validators.required]),
    swapTrailerNumber: new FormControl(null)
  });

  constructor(
    private configurationService: AppClientConfigurationService,
    private stepperService: TransportAttachDetachStepperService
  ) {

    this.stepperModel = this.stepperService.stepperModel;

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      return this.formGroup.valid;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {

    this.formGroup.patchValue({
      trailerNumberPlate: this.stepperModel.workingData.trailerNumberPlate,
      swapTrailerNumber: this.stepperModel.workingData.swapTrailerNumber
    });

    this.formGroup.valueChanges.subscribe(value => {
      this.stepperModel.workingData.trailerNumberPlate = value.trailerNumberPlate;
      this.stepperModel.workingData.swapTrailerNumber = value.swapTrailerNumber;
    });

  }

  swapTrailerEnabled() {
    return this.configurationService.isPropertyTrue(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }


}
